import React from "react";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(theme => ({
    icon: {
        fontSize: 15,
        color: theme.palette.text.disabled,
        cursor: "help",
        flexShrink: 0,
        verticalAlign: "middle",
        marginLeft: 4,
        "&:hover": { color: theme.palette.text.secondary },
    },
    tip: {
        fontSize: 12.5,
        lineHeight: 1.5,
        maxWidth: 300,
        whiteSpace: "pre-line",
    },
}));

const InfoHint = ({ text }) => {
    const { classes } = useStyles();
    if (!text) return null;

    return (
        <Tooltip
            title={<span className={classes.tip}>{text}</span>}
            arrow
            enterTouchDelay={0}
            leaveTouchDelay={6000}
        >
            <InfoOutlinedIcon className={`${classes.icon} no-imprimir`} tabIndex={0} role="button" aria-label={text} />
        </Tooltip>
    );
};

export default InfoHint;
